
import { AuthService } from "../services/auth-service";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppSection from "@/components/login/LoginSection.vue";
import AppButton from "@/components/login/LoginButton.vue";
import { FormLike } from "winfakt-vue-components/src/mixins/form-like";
import { HttpError } from "../utils/services/http-error";
import AppEnterTotp from "@/components/login/EnterTotp.vue";
import { ToolbarService } from "@/services/toolbar-service";
import { BrowserInfo } from "@/utils/browser";
import { ConfirmResult } from "winfakt-vue-components";
import { TranslateResult } from "vue-i18n";

interface ILoginOptions {
	totp?: string
	userDeviceConfrimSet?:boolean
}

export default FormLike.extend({
	data() {
		return {
			input: {
				username: "",
				password: "",
				workspace: "",
			},
			doLogin: false as boolean | any,
			loginResult: null as string | any,
			editWorksSpace: false as boolean | any,
			confirmLoginWithTotp: false,
			AuthService,
			passwordVisible: false
		};
	},
	computed: {
		firstName(): string {
			if (!AuthService.wfUser) {
				return "";
			}
			return AuthService.wfUser.Firstname;
		},
		disableFormElement(): boolean {
			return this.doLogin && !this.loginResult;
		},
		disableButton(): boolean {
			return !this.isValid || (this.doLogin && !this.loginResult);
		},
		passwordIconRight():string{
			if (this.passwordVisible){
				return "eye";
			}
			return "eye-slash";
		},
		passwordIconTooltip():TranslateResult{
			if (this.passwordVisible){
				return this.$ct("hide-password");
			}
			return this.$ct("show-password");
		}
	},
	watch: {
		input: {
			deep: true,
			handler() {
				this.loginResult = null;
			}
		}
	},
	methods: {
		async submit(opts:ILoginOptions = {}) {
			await this.$nextTick();
			this.validate();
			if (!this.isValid) {
				return;
			}
			this.doLogin = true;
			try {
				await AuthService.login(
					this.input.username,
					this.input.password,
					{
						workspaceUrl: this.input.workspace,
						totp: opts.totp,
						userDeviceConfrimSet: opts.userDeviceConfrimSet
					}
				);
				localStorage.setItem("last-workspace", this.input.workspace);
			} catch (e) {
				let err = e as HttpError;
				err.dontShow = true;
				if (err.key == "TOTP_REQUEIRED") {
					this.confirmLoginWithTotp = true;
				} else if (err.key == "LOGIN_SET_USER_DEVICE_CONFIRM_NOT_SET"){
					await this.handleUserDeviceError(opts);
				} else{
					console.log(err);
					this.loginResult = err.getText();
				}
			}
			this.doLogin = false;
		},
		async handleUserDeviceError(opts:ILoginOptions){
			if (!BrowserInfo.isElectron()) {
				let text = this.$ct("this-account-can-only-login-in-electron-app");
				await this.$wf.dialog(text, this.$ct("common.Ok"), this.$ct("common.error"), "warning");
				return;
			}
			let text = this.$ct("user-device-warning-set-this-device-as-default");
			let confirm = await this.$wf.confirm(text, this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "info");
			if (confirm == ConfirmResult.YES){
				opts.userDeviceConfrimSet = true;
				await this.submit(opts);
			}
		},
		submitWithTotp(totp: string) {
			this.submit({totp});
		},
	},
	mounted() {
		this.validate();
		if (this.$route.query.workspace) {
			this.input.workspace = this.$route.query.workspace as string;
			let query = {...this.$route.query};
			delete query.workspace;
			this.$router.replace({...this.$route, query} as any);
			localStorage.setItem("last-workspace", this.input.workspace);
		} else {
			let ws = localStorage.getItem("last-workspace");
			if (ws) {
				this.input.workspace = ws;
			}
		}
		if (this.$route.query.email) {
			this.input.username = this.$route.query.email as string;
			let p = this.$refs.password as HTMLInputElement;
			p.focus();
		}else{
			let u = this.$refs.username as HTMLInputElement;
			u.focus();
		}
		let splashEl = document.getElementById("splash");
		setTimeout(()=>{
			this.input.username = (this.$refs.username as HTMLInputElement).value;
			this.input.password = (this.$refs.password as HTMLInputElement).value;
		}, 1000);
		ToolbarService.title = this.$ct("common.login");
		if (!splashEl) return;
		splashEl.remove();
	},
	i18nEx: {
		componentPrefix: "views.TheLogin"
	},
	components: {
		AppContainer,
		AppTitle,
		AppText,
		AppSection,
		AppButton,
		AppEnterTotp
	}
});
